import html from '../assets/html.png';
import css from '../assets/css.png';
import js from '../assets/js.png';
import jquery from '../assets/jquery.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';
import node from '../assets/node.png';
import bootstrap from '../assets/bootstrap.png';
import git from '../assets/git.png';
import dynamodb from '../assets/dynamodb.png';
import S3 from '../assets/S3.png';
import cognito from '../assets/cognito.png';
import cloudwatch from '../assets/cloudwatch.png';
import lambda from '../assets/lambda.png';

const getTechs = [
    {
        techName: 'html',
        techImg: html
    },
    {
        techName: 'css',
        techImg: css
    }, {
        techName: 'js',
        techImg: js
    },
    {
        techName: 'jquery',
        techImg: jquery
    },
    {
        techName: 'react',
        techImg: react
    },
    {
        techName: 'sass',
        techImg: sass
    },
    {
        techName: 'node',
        techImg: node
    },
    {
        techName: 'bootstrap',
        techImg: bootstrap
    },
    {
        techName: 'git',
        techImg: git
    },
    {
        techName: 'AWS dynamoDb',
        techImg: dynamodb
    },
    {
        techName: 'AWS S3',
        techImg: S3
    },
    {
        techName: 'AWS Cognito',
        techImg: cognito
    },
    {
        techName: 'AWS cloudwatch',
        techImg: cloudwatch
    },
    {
        techName: 'AWS Lambda',
        techImg: lambda
    }
]
export default getTechs;
